import AxiosClient from "../../../services/axios.services";

class FactoresCriticidadServices {
  getFactoresCriticidad = (params) =>
    AxiosClient.get("/api/app/carrera_sucesion_factores_criticidad/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveFactoresCriticidad = (data) =>
    AxiosClient.post("/api/app/carrera_sucesion_factores_criticidad/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFactoresCriticidad = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_sucesion_factores_criticidad/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFactoresCriticidad = (id) =>
    AxiosClient.delete(`/api/app/carrera_sucesion_factores_criticidad/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FactoresCriticidadServices();
